var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('br'),_c('br'),_c('br'),_c('br'),_c('p',[_vm._v(_vm._s(_vm.translate('welcomeMessage')))]),_c('h1',[_vm._v(_vm._s(_vm.translate('start')))]),_c('p',[_vm._v(_vm._s(_vm.translate('description')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }